import treeIcon from '@graniot/app_frontend/src/assets/tree.png'

import React from 'react'
import { isWidthUp } from '@material-ui/core/withWidth'
import { Typography, Icon, Button } from '@material-ui/core'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import ImageIcon from '@material-ui/icons/Image'

const useStyles = makeStyles((theme) =>
	createStyles({
		treelegend: {
			position: 'fixed',
			left: (props) =>
				isWidthUp('sm', props.width)
					? props.openDrawer
						? props.drawerWidth +
						  10 +
						  (props.isDemLegendVisible ? 290 : 0)
						: props.isDemLegendVisible
						? 300
						: 10
					: 10,
			zIndex: 400,
			bottom: (props) => (isWidthUp('sm', props.width) ? 16 : 60),
		},
		button: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: '#fff',
			color: '#000',
			'&:hover': {
				background: '#fff',
			},
		},
		icon: {
			marginRight: theme.spacing(1),
		},
	})
)

const TreeLayerLegend = ({
	plantsCounter,
	farms,
	openDrawer,
	drawerWidth,
	isDemLegendVisible,
	width,
}) => {
	const classes = useStyles({
		isDemLegendVisible,
		openDrawer,
		drawerWidth,
		width,
	})
	const totalTrees = plantsCounter?.reduce((acc, farm) => {
		return acc + farm.num_plants
	}, 0)
	const treesOnCurrentFarm =
		plantsCounter?.find(
			(farm) => farm.id_farm == farms.find((f) => f.checked).id
		)?.num_plants || 0

	return (
		<div className={classes.treelegend}>
			<Button
				disableRipple
				disableFocusRipple
				className={classes.button}
				variant="contained"
				size="small"
			>
				<img src={treeIcon} alt="Icon" className={classes.icon} />
				{`${treesOnCurrentFarm}/${totalTrees}`}
			</Button>
		</div>
	)
}

export default TreeLayerLegend
